import React from "react";

export default props => (
    <div className="test-page-content-inner test-page-start">
        <img src="/images/Logo.png" alt="CPP logo" />
        <h1>Temporary issue encountered. Please try again in 2 minutes.</h1>
    </div>
);
